<ion-card-content class="ion-padding-horizontal-2 ion-padding-vertical-0">
    <app-single-asset-scan *ngIf="!props.multi" [scannedAsset]="currentAssets[0]" [props]="$any(props)" [key]="updatedKey"
        (assetsEvent)="saveAsset($any($event))">
    </app-single-asset-scan>
    <app-multi-asset-scan *ngIf="props.multi" [scannedAssets]="currentAssets" [props]="$any(props)"
        (assetsEvent)="saveAsset($any($event))">
    </app-multi-asset-scan>
</ion-card-content>